import { useState, useEffect } from 'react'
import { useSetRecoilState, useRecoilState } from 'recoil'
import { sceneState } from '../../stores/studioAtoms'
import { useNavigate, useParams } from 'react-router-dom'
import { getScenes, getMe } from '../../services/apis/StudioApi'
import Selector from './Selector'
import AlertModal from '../Modal/AlertModal'


export const SceneList = ({ isUsedOn, fit = false }) => {
    const [selected, setSelected] = useState({ name: "촬영 선택" })
    const [scene, setSceneState] = useRecoilState(sceneState)
    const navigate = useNavigate()
    const { schoolId } = useParams()
    const [scenes, setScenes] = useState([])
    const [currentUser, setCurrentUser] = useState(null)
    const [isAlertOpen, setIsAlertOpen] = useState(false)
    const [alertMessage, setAlertMessage] = useState('')

    useEffect(() => {
        getMe().then(res => setCurrentUser(res.data)).catch(err => console.error(err))
        getScenes(schoolId).then(res => {
            setScenes(res.data)
        })
    }, [])

    const canAccessScene = (scene) => {
        if (!scene.is_locked) return true;
        if (!currentUser) return false; // User not loaded yet, assume locked
        if (currentUser.is_superuser) return true;
        return scene.locked_by_user_id === currentUser.id;
    }

    const setScene = (selected) => {
        if (!canAccessScene(selected)) {
            setAlertMessage('진행중인 촬영은 선택할 수 없습니다.');
            setIsAlertOpen(true);
            return;
        }

        setSelected(selected)
        setSceneState(selected)
        localStorage.setItem("currentScene", JSON.stringify(selected))
        if (isUsedOn === "shot") navigate(`/studio/school/${schoolId}/photo`)
        if (isUsedOn === "settings") navigate(`/studio/school/${schoolId}/scene/${selected.id}/settings`)
    }
    const sceneLabel = (scene) => {
        if (scene.is_locked) {
            return `${scene.name} (촬영중)`
        }
        return scene.name
    }

    if (scenes.length === 0) {
        return <div>먼저, 촬영을 추가해주세요</div>
    }
    return (
        <>
            <Selector
                label={scene ? scene.name : "촬영 선택"}
                items={scenes}
                handleChange={setScene}
                itemLabel={sceneLabel}
                fit={fit}
            />
            <AlertModal
                isOpen={isAlertOpen}
                onClose={() => setIsAlertOpen(false)}
                title="알림"
                message={alertMessage}
            />
        </>
    )
}

export default SceneList